import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
    constructor() {
    }

    transform(date: any, format: string): any {
        if (date) {
            return moment(date).format(format);
        }
    }
}

